<template>
    <div>
        <div class="container-fluid">
            <CRow>
                <CCol col="12" xl="12">
                    <CCard>
                        <CCardHeader>
                            <strong>{{ isEdit ? 'Upraviť' : 'Pridať' }} cenové pravidlo</strong>
                            <div class="card-header-actions">
                                <small class="text-muted">{{ cabin.title }}</small>
                            </div>
                        </CCardHeader>
                        <CCardBody>
                        <a-form :form="form" @submit="handleSubmit">

                            <a-form-item label="Názov sezóny">
                                <a-input v-decorator="['season_name', {rules: [{required: true, message: 'Zadajte názov sezóny'}]}]"
                                    placeholder="napr. Letná sezóna, Vianoce a Silvester" />
                            </a-form-item>

                            <a-row :gutter="16">
                                <a-col :span="12">
                                    <a-form-item label="Platnosť od">
                                        <a-date-picker v-decorator="['valid_from', {rules: [{required: true}]}]"
                                            format="DD.MM.YYYY" style="width: 100%" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="Platnosť do">
                                        <a-date-picker v-decorator="['valid_to', {rules: [{required: true}]}]"
                                            format="DD.MM.YYYY" style="width: 100%" />
                                    </a-form-item>
                                </a-col>
                            </a-row>

                            <a-form-item label="Režim">
                                <a-select v-decorator="['mode', {initialValue: 'whole'}]">
                                    <a-select-option value="whole">Celý objekt</a-select-option>
                                    <a-select-option value="apartment">Apartmán</a-select-option>
                                    <a-select-option value="both">Oboje</a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-row :gutter="16">
                                <a-col :span="8">
                                    <a-form-item label="Min. počet nocí">
                                        <a-input-number v-decorator="['min_nights', {initialValue: 1}]"
                                            :min="1" style="width: 100%" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="8">
                                    <a-form-item label="Max. počet nocí">
                                        <a-input-number v-decorator="['max_nights']"
                                            :min="1" placeholder="Neobmedzené" style="width: 100%" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="8">
                                    <a-form-item label="Priorita">
                                        <a-input-number v-decorator="['priority', {initialValue: 0}]"
                                            :min="0" style="width: 100%" />
                                    </a-form-item>
                                </a-col>
                            </a-row>

                            <a-divider>Ceny podľa počtu osôb (€/noc)</a-divider>

                            <a-row :gutter="16">
                                <a-col :span="8" v-for="n in 6" :key="n">
                                    <a-form-item :label="`${n} ${n === 1 ? 'osoba' : n < 5 ? 'osoby' : 'osôb'}`">
                                        <a-input-number v-model="pricesPerPerson[n]"
                                            :min="0" suffix="€" style="width: 100%" />
                                    </a-form-item>
                                </a-col>
                            </a-row>

                            <a-divider>Ceny za deti podľa veku (€/noc)</a-divider>

                            <div v-for="(child, index) in childPrices" :key="index" class="mb-3">
                                <a-row :gutter="16" type="flex" align="middle">
                                    <a-col :span="6">
                                        <a-input-number v-model="child.age_from"
                                            placeholder="Vek od" :min="0" :max="18" style="width: 100%" />
                                    </a-col>
                                    <a-col :span="6">
                                        <a-input-number v-model="child.age_to"
                                            placeholder="Vek do" :min="0" :max="18" style="width: 100%" />
                                    </a-col>
                                    <a-col :span="8">
                                        <a-input-number v-model="child.price"
                                            placeholder="Cena" :min="0" suffix="€" style="width: 100%" />
                                    </a-col>
                                    <a-col :span="4">
                                        <a-button type="danger" icon="delete" @click="removeChildPrice(index)" />
                                    </a-col>
                                </a-row>
                            </div>
                            <a-button type="dashed" icon="plus" @click="addChildPrice" block>
                                Pridať vekovú kategóriu
                            </a-button>

                            <a-divider />

                            <a-form-item label="Príplatok za víkend (€)">
                                <a-input-number v-decorator="['weekend_surcharge', {initialValue: 0}]"
                                    :min="0" suffix="€" style="width: 200px" />
                                <small class="form-text text-muted">Automaticky sa pripočíta k cene za piatok-nedeľu</small>
                            </a-form-item>

                            <a-form-item>
                                <a-checkbox v-decorator="['active', {valuePropName: 'checked', initialValue: true}]">
                                    Aktívne
                                </a-checkbox>
                            </a-form-item>

                            <a-form-item>
                                <a-button type="primary" html-type="submit" :loading="loading">
                                    {{ isEdit ? 'Aktualizovať' : 'Vytvoriť' }}
                                </a-button>
                                <a-button @click="$router.go(-1)" class="ml-2">Zrušiť</a-button>
                            </a-form-item>
                        </a-form>
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
        </div>
    </div>
</template>

<script>
import {dataService} from "../_services";
import moment from 'moment';

export default {
    name: "cabin-pricing-edit",
    props: ['id', 'cabinId'],
    data() {
        return {
            form: this.$form.createForm(this),
            cabin: {},
            pricesPerPerson: {},
            childPrices: [
                {age_from: 0, age_to: 3, price: 0},
                {age_from: 3, age_to: 6, price: 15},
                {age_from: 6, age_to: 12, price: 25},
                {age_from: 12, age_to: 18, price: 35}
            ],
            loading: false,
            isEdit: false
        };
    },
    mounted() {
        this.isEdit = !!this.id;

        if (this.cabinId) {
            this.fetchCabin(this.cabinId);
        }

        if (this.isEdit) {
            this.fetchPricing();
        }
    },
    methods: {
        fetchCabin(id) {
            dataService.axiosFetch('content/cabins', id).then(result => {
                this.cabin = result;
            });
        },
        fetchPricing() {
            dataService.axiosFetch('cabin-pricing', this.id).then(result => {
                this.form.setFieldsValue({
                    season_name: result.season_name,
                    valid_from: moment(result.valid_from),
                    valid_to: moment(result.valid_to),
                    mode: result.mode,
                    min_nights: result.min_nights,
                    max_nights: result.max_nights,
                    priority: result.priority,
                    weekend_surcharge: result.weekend_surcharge,
                    active: result.active
                });

                if (result.prices_per_person) {
                    this.pricesPerPerson = JSON.parse(result.prices_per_person);
                }

                if (result.child_prices) {
                    this.childPrices = JSON.parse(result.child_prices);
                }

                this.fetchCabin(result.cabin_id);
            });
        },
        addChildPrice() {
            this.childPrices.push({age_from: 0, age_to: 18, price: 0});
        },
        removeChildPrice(index) {
            this.childPrices.splice(index, 1);
        },
        handleSubmit(e) {
            e.preventDefault();
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.loading = true;

                    const data = {
                        ...values,
                        cabin_id: this.cabinId || this.cabin.id,
                        valid_from: values.valid_from.format('YYYY-MM-DD'),
                        valid_to: values.valid_to.format('YYYY-MM-DD'),
                        prices_per_person: JSON.stringify(this.pricesPerPerson),
                        child_prices: JSON.stringify(this.childPrices)
                    };

                    const url = this.isEdit ? `cabin-pricing/${this.id}` : 'cabin-pricing';

                    dataService.axiosPost(url, data).then(() => {
                        this.loading = false;
                        this.$router.push('/cabin-pricing');
                    });
                }
            });
        }
    }
};
</script>

<style scoped>
.ant-form-item {
    margin-bottom: 16px;
}
</style>
